import React from 'react';
import {useField} from 'formik';
import TextArea, {Props as TextAreaProps} from './text-area';

/**
  For use in Formik forms.

  Usage example:
  <FormikTextArea
    name="bio"
    placeholder="Enter a brief description about yourself."
  />
*/

const FormikTextArea = (props: {name: string} & TextAreaProps) => {
  const [field, meta] = useField(props.name);
  return (
    <TextArea
      {...props}
      {...field}
      error={meta.touched ? meta.error : ''}
      {...(props.onChange && {
        onChange: (e) => {
          field.onChange(e);
          props.onChange?.(e);
        },
      })}
    />
  );
};

export default FormikTextArea;
